<ng-container *notInProductCode="productCode.NonRenewing">
      <div class="mobile-navigation-wrapper container">
        <div class="mobile-navigation d-flex flex-row align-items-center pb-2 mb-2" (scroll)="onNavScroll($event)">
          <div class="navigation" routerLink="/rewards">
            <span class="material-icons icons material-symbols-outlined gloss mb-1">redeem</span>
            <a class="text-white font-size-14">{{ 'nav.rewards' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/challenges">
            <span class="material-icons icons material-symbols-outlined gloss mb-1">emoji_events</span>
            <a class="text-white font-size-14">{{ 'nav.challenges' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/games">
            <span class="material-icons icons material-symbols-outlined gloss mb-1">sports_esports</span>
            <a class="text-white font-size-14">{{ 'nav.games' | translate }}</a>
          </div>
        </div>

        <!-- Right shadow -->
        <div
          class="scroll-shadow"
          [class.hidden]="isNavAtEnd"
          [ngClass]="{
            'scroll-shadow-primary': rewards,
            'scroll-shadow-secondary': nations,
          }"
        ></div>
      </div>
    </ng-container>